import React from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authAction";
import IntelLogo from "../../static/img/Intel.png";
import KMVLogo from "../../static/img/kmv.png";
import AISCLogo from "../../static/img/aisc.png";
import styled from "styled-components";
import { authFetch } from "../../utils/api";

const Logo = styled.img`
  width: auto;
  max-width: 100%;
  height: auto !important;
  max-height: 60px;
`;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedCertificateProgram:
        localStorage.getItem("selectedCertificateProgram") || "impact_fest",
    };
  }

  getProfile = () => {
    const id = localStorage.getItem("studentId");
    authFetch(`${process.env.REACT_APP_API_URL}/users/students/` + id)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            data: result.data,
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  };

  componentDidMount() {
    this.getProfile();
  }

  render() {
    return (
      <React.Fragment>
        <div className="position-fixed w-100 header-wrapper">
          <div className="header-container">
            <div className="row header-logos-container content-container py-md-2">
              <div className="col-4 header-col d-flex align-items-center justify-content-start">
                <Logo className="header-logo" src={KMVLogo} alt="KMVLogo" />
              </div>
              <div className="col-4 header-col d-flex align-items-center justify-content-center">
                <Logo
                  className="header-logo aisc-logo"
                  src={AISCLogo}
                  alt="aiscLogo"
                />
              </div>
              <div className="col-4 header-col d-flex align-items-center justify-content-end">
                <Logo
                  className="header-logo intel-logo p-md-2"
                  src={IntelLogo}
                  alt="IntelLogo"
                />
              </div>
            </div>
          </div>

          {!this.props.hideSubHeader && (
            <header className="header px-2 px-md-0">
              <nav
                className={
                  "navbar navbar-expand-lg py-0  " +
                  (this.props.bgColor && this.props.bgColor === "white"
                    ? "custom-nav white-bg"
                    : "")
                }
              >
                <div className="container">
                  <ul style={{ display: "contents" }}>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/dashboard">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/letslearn">
                        Let's Learn
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link border-0 bg-transparent"
                        id="indiaAIDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Events
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="indiaAIDropdown"
                      >
                        <a className="dropdown-item" href="/event">
                          Weekly Sessions
                        </a>
                        <a className="dropdown-item" href="/challenge">
                          Challenges
                        </a>
                        <a
                          className="dropdown-item"
                          href={process.env.REACT_APP_FORUM_URL}
                        >
                          Forum
                        </a>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link page-scroll" href="/blog">
                        Blogs
                      </a>
                    </li>
                    <li className="nav-item" onClick={this.onLogoutClick}>
                      <a href="/AIProjects" className="nav-link page-scroll">
                        AI Projects
                      </a>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link border-0 bg-transparent"
                        id="tinkerprenuerDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        AI Tinkerpreneur
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="tinkerprenuerDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/india-ai-tinkerpreneur-2025"
                        >
                          2025
                        </a>
                        <a className="dropdown-item" href="/tinkerpreneur-2026">
                          2026
                        </a>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link border-0 bg-transparent"
                        id="indiaAIDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Impact Festival
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="indiaAIDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/india-ai-impact-festival-2024"
                        >
                          2024
                        </a>
                        <a
                          className="dropdown-item"
                          href="/india-ai-impact-festival-2025"
                        >
                          2025
                        </a>
                      </div>
                    </li>

                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link border-0 bg-transparent"
                        id="certificatesDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Certificates
                      </a>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="certificatesDropdown"
                      >
                        <a
                          className="dropdown-item"
                          href="/generate-certificate"
                          onClick={(e) => {
                            localStorage.setItem(
                              "selectedCertificateProgram",
                              "impact_fest"
                            );
                            this.setState({
                              selectedCertificateProgram: "impact_fest",
                            });
                          }}
                        >
                          Impact Festival
                        </a>
                        <a
                          className="dropdown-item"
                          href="/generate-certificate"
                          onClick={(e) => {
                            localStorage.setItem(
                              "selectedCertificateProgram",
                              "bootcamp"
                            );
                            this.setState({
                              selectedCertificateProgram: "bootcamp",
                            });
                          }}
                        >
                          BootCamp
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav ml-auto py-1">
                      <li className="nav-item d-flex align-items-center">
                        <div className="dropdown d-flex align-items-center">
                          <a className="nav-link page-scroll" href="/profile">
                            {this.state.data.map((item) => item.first_name)}
                          </a>
                          <div
                            className="profile-picture"
                            style={{
                              backgroundImage: `url(${this.state.data.map(
                                (item) => item.profile_pic
                              )})`,
                            }}
                          ></div>
                          <div className="dropdown-content shadow">
                            <a href="/profile" style={{ color: "black" }}>
                              Profile
                            </a>
                            <div className="border-line"></div>
                            <a
                              href="/"
                              onClick={() => this.props.logoutUser()}
                              style={{ color: "black" }}
                            >
                              Logout
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </header>
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(Header);
